import React from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import { useCrushShyT } from '../../../hooks/useCrushShyT';

const CrushShyPageHeader = ({ title, subtitle, action }) => {
  const t = useCrushShyT();
  const { toggleLanguage } = useLanguage();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-9 h-9 rounded-lg bg-pink-500/15 flex items-center justify-center">
            <Heart className="w-5 h-5 text-pink-400" fill="currentColor" />
          </div>
          <span className="text-xs font-semibold uppercase tracking-wider text-pink-400/90">CrushShy</span>
          <button
            type="button"
            onClick={toggleLanguage}
            className="ml-2 text-xs font-semibold px-2.5 py-1 rounded-md border border-pink-500/30 text-pink-300 hover:bg-pink-500/10 transition-colors"
            aria-label="Toggle language"
          >
            {t('langToggle')}
          </button>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white">{title}</h1>
        {subtitle && <p className="text-gray-400 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
};

export default CrushShyPageHeader;
